module.exports = __webpack_public_path__ + "2b404dee5bc2b8b83afdea5eb3a6deef.MP3";